import { MathJax } from "better-react-mathjax";
import classNames from "classnames";
import styles from "./messageCard.module.css";

const MessageCard = ({ text, role, ...rest }) => {
  return (
    <div
      className={classNames(styles.messageLine, {
        [styles.ownMessage]: role === "USER",
      })}
    >
      <div
        className={classNames(styles.messageCard, {
          [styles.ownMessage]: role === "USER",
        })}
        style={{ whiteSpace: "pre-wrap" }}
      >
        <MathJax inline dynamic>
          {text}
        </MathJax>
      </div>
    </div>
  );
};

export default MessageCard;
